jQuery(document).ready(function($) {
   	// Start marquee
     if ($(window).width() < 580){
       if($('.marquee_text').length > 0){
          $('.marquee_text').marquee({
          direction: 'left',
          duration: 15000,
          gap: 15,
          delayBeforeStart: 0,
          duplicated: true,
          startVisible: true
          });
       }
     }

    /*if ($(window).width() > 960){ 
        $("header").hover(function() {
        $(this).toggleClass("hover-effect");
      });
    }*/
    //Header Search Icon
    if($('.header__icon-touch--search').length > 0){
      $('.header__icon-touch--search').click(function() {
        $('.search-bar').slideToggle();
      });
     }
  
    if($('.mobile_search').length > 0){
      $('.mobile_search').click(function() {
        $('.mobile-search-bar').slideToggle();
      });
    }
    
    if($('a#unmute').length > 0){
      $(document).on('click', 'a#unmute', function() {
        var video = document.getElementById("hero-video");
        var volumeIcon = document.querySelector('.icon-button-volume');
        var muteIcon = document.querySelector('.icon-button-volume-mute');
        if (video.muted) {
            video.muted = false;
            volumeIcon.style.display = 'none';
            muteIcon.style.display = 'block';
        } else {
            video.muted = true;
            volumeIcon.style.display = 'block';
            muteIcon.style.display = 'none';
        }
      });
    }
     
    if($('.scroll-to-widget').length > 0){
      $('.scroll-to-widget').on('click', function(event) {
        event.preventDefault();
        var target = $('[data-oke-widget]');
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000);
      });  
    }
    if($('.down-arrow a#down').length > 0){
      $(".down-arrow a#down").on("click", function(event) {
          event.preventDefault();
          var announcementHeight = $(".announcement-bar-outer").outerHeight();
          var headerHeight = $(".header__inner").outerHeight();
          var totalHeight = announcementHeight + headerHeight;
            $('html, body').animate({
                scrollTop: $(".collection-section .collection-banner").offset().top - totalHeight
            }, 1000);
      });
    }

setTimeout(function() {
  $('.product-item__product-form button').prop('disabled', false);
}, 500);

if ($('.product-item').length > 0) {

  $('body').on('click', '.product-item .colour_variant label', function () {
  var handle = $(this).siblings('input').data('handle');
  var current_ele = $(this).closest('.product-item');

  current_ele.find('.product-item__image-link').addClass('loading');
  current_ele.find('.colour_variant input').removeAttr('checked');
  current_ele.find('.colour_variant label').css('border', 'none');
  $(this).css('border', '1px solid #431C28');
  $(this).siblings('input').attr('checked', 'checked');

  $.ajax({
    url: '/products/' + handle + '.js',
    type: 'GET',
    dataType: 'json',
    success: function (product) {
      if (!product) return;

      current_ele.find('.product-item__product-form input[name="id"]').val(product.variants[0].id);
      current_ele.find('[data-quick-shop-trigger="quick-add"]').attr('data-product-id', product.variants[0].id);
      current_ele.attr('data-current-handle', handle);
      current_ele.find('.product-item__image-link').attr('href', '/products/' + handle);
      current_ele.find('.product-item__product-title a').attr('href', '/products/' + handle).text(product.title);

      var imageLink = current_ele.find('.product-item__image-link');
      var firstImage = product.images && product.images.length > 0 ? product.images[0] : null;
      var media = product.media || [];
      var videoMedia = media.find(m => m.media_type === 'video');

      imageLink.find('.product-item__image--two').remove();

      if (firstImage) {
        var mainImage = imageLink.find('.product-item__image--one img').first();
        mainImage.attr({
          src: firstImage,
          srcset: firstImage,
          alt: product.title
        });
      }

      if (videoMedia && videoMedia.sources && videoMedia.sources[0]) {
        var videoSrc = videoMedia.sources[0].url;
        var videoElement = $(`
          <div class="image product-item__image product-item__image--two aspect-ratio--portrait loaded" style="--object-fit: cover;">
            <video muted loop playsinline preload="none" class="variant-video">
              <source src="${videoSrc}" type="video/mp4">
            </video>
          </div>
        `);
        imageLink.append(videoElement);
      } else if (product.images && product.images[1]) {
        var secondImage = product.images[1];
        var imgEl = $(`
          <div class="image product-item__image product-item__image--two aspect-ratio--portrait loaded" style="--object-fit: cover;">
            <img src="${secondImage}" alt="${product.title}" />
          </div>
        `);
        imageLink.append(imgEl);
      }

        var $sizeList = current_ele.find('.size_variant ul#variant-selector');
        if ($sizeList.length) {
          $sizeList.empty();

          var sizeOptionIndex = -1;
          if (product.options && product.options.length > 0) {
            product.options.forEach(function(opt, index) {
              if (opt.name.toLowerCase() === 'size') sizeOptionIndex = index;
            });
          }

          if (sizeOptionIndex >= 0) {
            product.variants.forEach(function(variant) {
              var sizeValue = variant.options[sizeOptionIndex];
              if (sizeValue) {
                var li = $('<li>')
                  .text(sizeValue)
                  .attr({
                    'data-size': sizeValue,
                    'data-value': variant.id
                  })
                  .toggleClass('out-of-stock', !variant.available);

                $sizeList.append(li);
              }
            });
          }
        }

      current_ele.find('.product-item__image-link').removeClass('loading');
    },
    error: function (xhr) {
      console.error('Error fetching product data:', xhr);
    }
  });
});


  $('body').on('click', '.product-item .size_variant li', function() {
    var variantId = $(this).data('value');
    var current_ele = $(this).closest('.product-item');
    var $form = current_ele.find('.product-item__product-form');

    if ($(this).hasClass('out-of-stock')) return;

    $form.find('input[name="id"]').val(variantId);
    $form.find('[data-quick-shop-trigger="quick-add"]').attr('data-product-id', variantId);

    current_ele.find('.size_variant li').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.product-item').find(".product-item__hoverless-quick-view-button").click();
  });


 $('body').on('submit', '.product-item__product-form', function(e){
    e.preventDefault();
    var $form = $(this);
    var variantId = $form.find('input[name="id"]').val();

    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: 1 },
      dataType: 'json',
      success: function() {
        $.ajax({
          url: '/?sections=quick-cart',
          type: 'GET',
          success: function(data) {
            var $html = $(data);
            var $newCart = $html.find('.quick-cart');
            $('.quick-cart').replaceWith($newCart);
            $('body').addClass('quick-cart--active');
          },
          error: function(xhr) {
            console.error('Quick cart refresh error', xhr);
          }
        });
      },
      error: function(xhr) {
        console.error('Add to cart error', xhr);
      }
    });
  });

  $('.product-item').hover(
  function() {
      $(this).find('.product-item__image--two').toggleClass('active');
  });
  
}

$('body').on('click', '.product-item .size_variant label', function() {
  var $input = $(this).siblings('input');
  var variantId = $input.val();
  var current_ele = $(this).closest('.product-item');
  current_ele.find('input[name="id"]').val(variantId);

  current_ele.find('.colour_variant label, .size_variant label').css('border', 'none');
  $(this).css('border', '1px solid #431C28');

});


 
    if($('.owl-carousel').length > 0){
      var owl = $('.owl-carousel');
      owl.owlCarousel({
        items: 2,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 35000,        
      });
    }

    var viewportWidth = $(window).width();
    if (viewportWidth <= 768) {
        $('.mobileDiv').show();
    } else {
       $('.desktopDiv').show();
    } 

    if ($('.product-item__media--multiple-images').length > 0) {
      $(document)
        .on('mouseenter', '.product-item__media--multiple-images', function() {
          const $media = $(this);
          $media.addClass('active');
          $media.find('.product-item__image--two').addClass('active');

          const video = $media.find('.product-item__image--two video')[0];
          if (video) {
            video.currentTime = 0;
            video.play().catch(() => {});
          }
        })
        .on('mouseleave', '.product-item__media--multiple-images', function() {
          const $media = $(this);
          $media.removeClass('active');
          $media.find('.product-item__image--two').removeClass('active');

          const video = $media.find('.product-item__image--two video')[0];
          if (video) {
            video.pause();
          }
        });
    }

    // Cache the header and hero section elements
    var $header = $('header');
    var $heroSection = $('.hero-section');
    var headerHeight = 112;

    // Function to check scroll position and update header class
    if($('.hero-section').length > 0){
      function checkScroll() {
          var heroBottom = $heroSection.offset().top + $heroSection.outerHeight();
          if ($(window).scrollTop() > heroBottom - headerHeight) {
              $header.addClass('is-sticky');
          } else {
              $header.removeClass('is-sticky');
          }
      }
      // Bind the checkScroll function to the scroll event
      $(window).on('scroll', checkScroll);
      // Run the checkScroll function on page load
      checkScroll();
     }

    if ($('.template-collection .product-item').length > 0) {
        $('.product-item .product-item__text h4').matchHeight({
            property: 'min-height'
        });
    }

    $('.filter-bar__inner').on('click', function() {
        $(this).toggleClass('fullwidth');
    });
    
    /*mobile deskop class toggle*/
    function handleElementRemoval() {
        var isMobile = window.innerWidth <= 960;
        if (isMobile) {
            $('.desktop-video').remove();
            $('.desktop').remove();
        } else {
            $('.mobile-video').remove();
            $('.mobile').remove();
        }
    }
    handleElementRemoval();
    $(window).on('resize', function() {
        handleElementRemoval();
    });
  /* video play/pause on scroll */
  if($('#hero-video').length > 0){
    var video = $('#hero-video').get(0);
    $(window).on('scroll', function() {
        var videoTop = $('.hero-area, .collection-hero').offset().top;
        var videoBottom = videoTop + $('.hero-area, .collection-hero').height();
        var scrollPos = $(window).scrollTop();
        var windowBottom = scrollPos + $(window).height();
        if (windowBottom > videoTop && scrollPos < videoBottom) {
            video.play();
        } else {
            video.pause();
        }
    });
  }
});
